import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import classes from "./QuizReportPage.module.scss";
import {
  getClassNameActionHandler,
  getDrillDownQuizReportActionHandler,
  getQuizReportActionHanlder,
  getTenantUsersActionHandler,
  getUserGroupActionhandler,
  getUserResponseToQuestionActionHandler,
} from "../../../store/actions/actionHandlers/reportActionHandler";
import Dropdown from "../../../components/Common/ReactForm/Dropdown/Dropdown";
import Button from "../../../components/Common/Button/Button";
import MainLayout from "../../../components/Common/MainLayout/MainLayout";
import { quizReport } from "../../../utils/mainTabs/reports/quizReport";
import { useNavigate, useOutletContext } from "react-router";
import DataTable from "../../../components/Common/DataTable/DataTable";
import { useFetchData } from "../../../hooks/useFetchData";
import { useCallback } from "react";
import Modal from "../../../components/Common/Modal/Modal";
import { quizModalReport } from "../../../utils/mainTabs/reports/quizModalReport";

import DownloadIconSmall from "../../../components/Common/SvgIcons/CommonIcons/DownloadIconSmall";
import { quizUserResponseToQuestionsModal } from "../../../utils/mainTabs/reports/quizUserReponseToQuestionsModal";
import TickIcon from "../../../components/Common/SvgIcons/ManageIcons/TickIcon";
import { FormattedMessage, injectIntl } from "react-intl";
import PreviousIcon from "../../../components/Common/SvgIcons/CommonIcons/PreviousIcon";

import { FormProvider, useForm } from "react-hook-form";
import InputHookForm from "../../../components/Common/Input/Input";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  getClassNameAction,
  getTenantUsersAction,
  getUserGroupAction,
} from "../../../store/actions/actionCreators/reportActionCreator";

export const quizReportSchema = yup.object().shape({
  userGroup: yup
    .array(
      yup.object().shape({
        Name: yup.string(),
        TypeId: yup.number(),
      })
    )
    .max(5, "Maximum 5 User are allowed"),
  ClassName: yup
    .array(
      yup.object().shape({
        Name: yup.string(),
        TypeId: yup.number(),
      })
    )
    .max(10, "Maximum 10 Classes are allowed"),
});

const QuizReportPage = ({ intl }) => {
  const reportState = useSelector((state) => state.reportReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pageNumber = 1;
  const pageSize = 20;
  const { userGroup, className, tenantUsers } = reportState;
  const { navLinks, columns, inputField } = quizReport;

  const { columns: modalColumns } = quizModalReport;

  const { columns: modalColumnss } = quizUserResponseToQuestionsModal;

  const { tenantName } = useOutletContext();

  const [reportMode, setReportMode] = useState("View");
  const [fromDate, setFromDate] = useState("");
  const [selectedUserGroup, setSelectedUserGroup] = useState([]);
  const [selectedClassName, setSelectedClassName] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [toDate, setToDate] = useState("");

  const [selectedUserGroupId, setSelectedUserGroupId] = useState("");
  const [selectedClassId, setSelectedClassId] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [Id, setId] = useState(0);
  const [questionId, setQuestionId] = useState(0);
  const [reportActionloader, setReportActionLoader] = useState(false);

  const [userGroupOptions, setUserGroupOptions] = useState([]);
  const [classNameOptions, setClassNameOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [filterParam, setFilterParam] = useState(2);
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const [userName, setUserName] = useState("none");
  const [questionData, setQuestionData] = useState([]);
  const [choiceList, setChoiceList] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [tableColumnss, setTableColumnss] = useState([]);
  const [Idd, setIdd] = useState(0);
  const [booleanSelectUser, setBooleanSelectUser] = useState(false);
  const [modalDataLoader, setModalDataLoader] = useState(false);
  useEffect(() => {
    dispatch(getClassNameActionHandler());
  }, []);

  useEffect(() => {
    if (
      tenantUsers.length == 0 ||
      userGroup.length == 0 ||
      className.length == 0
    ) {
      dispatch(getUserGroupActionhandler());
      dispatch(getClassNameActionHandler());
      dispatch(getTenantUsersActionHandler());
    }

    // if (selectedUserGroup?.length > 0) {
    //   const groupValue = [];
    //   selectedUserGroup?.map((e) => groupValue.push(e.label));
    //   setSelectedUserGroupId(groupValue);
    // }
    if (selectedClassName?.length > 0) {
      const classValue = [];
      selectedClassName?.map((opt) => classValue.push(opt.value));
      setSelectedClassId(classValue);
    } else {
      setSelectedClassId("");
    }
    if (selectedUser) {
      setSelectedUserId(selectedUser);
    }
  }, [dispatch, selectedUser, selectedClassName]); //selectedUserGroup, selectedClassName

  // let selectedUserGroupId = selectedUserGroup?.map((opt) => opt.label);
  // // let selectedUserId = 0;
  // // selectedUser?.map((opt) => opt.value);
  // let selectedClassId = selectedClassName?.map((opt) => opt.value);
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(
    (
      searchText,
      pageNumber,
      pageSize,
      setQuizReport,
      setTempQuizReport,
      setTotalRows
    ) =>
      getQuizReportActionHanlder(
        searchText,
        pageNumber,
        pageSize,
        setQuizReport,
        setTempQuizReport,
        setTotalRows,
        selectedClassId,
        fromDate,
        toDate,
        selectedUserId,
        selectedUserGroupId,
        reportMode,
        setReportActionLoader
      ),
    pageSize
  );

  useEffect(() => {
    const userGroupOption = userGroup?.map((d) => ({
      label: d.Name,
      value: d.TypeId,
    }));
    const classNameOption = className?.map((d) => ({
      label: d.Name,
      value: d.TypeId,
    }));
    const userOption = tenantUsers?.map((d) => ({
      label: d.FirstName + " " + d.LastName,
      value: d.Id,
    }));

    setUserOptions(userOption);
    setUserGroupOptions(userGroupOption);
    setClassNameOptions(classNameOption);
  }, [userGroup, className, tenantUsers]);

  const {
    data: modalData,
    setData: setModalData,
    updatedData: updatedModalData,
    setUpdatedData: setModalUpdatedData,
    totalRows: setModalTotalRows,
    handleCurrentPage: handlerModalCurrentPage,
    handleSearchQuery: handleModalSearchQuery,
  } = useFetchData(
    (
      searchText,
      pageNumber,
      pageSize,
      setDrillDownQuizReport,
      setTempDrillDownQuizReport,
      setTotalRows
    ) =>
      getDrillDownQuizReportActionHandler(
        searchText,
        pageNumber,
        pageSize,
        setDrillDownQuizReport,
        setTempDrillDownQuizReport,
        setTotalRows,
        Id,
        reportMode,
        setQuestionData,
        setModalDataLoader
      ),
    pageSize
  );

  const {
    data: modalsData,
    setData: setModalsData,
    updatedData: updatedModalsData,
    setUpdatedData: setModalUpdatedsData,
    totalRows: setModalTotalRowss,
    handleCurrentPage: handlerModalCurrentPages,
    handleSearchQuery: handleModalSearchQuerys,
  } = useFetchData(
    (
      searchText,
      pageNumber,
      pageSize,
      setUserResponseToQuestionsReport,
      setTempUserResponseToQuestionsReport,
      setTotalRows
    ) =>
      getUserResponseToQuestionActionHandler(
        searchText,
        pageNumber,
        pageSize,
        setUserResponseToQuestionsReport,
        setTempUserResponseToQuestionsReport,
        setTotalRows,
        Idd,
        filterParam,
        userName,
        setChoiceList
      ),
    pageSize
  );

  const handleUserPopUp = useCallback((Id) => {
    setId(Id);
    setIdd(0);
    setSelectedClassId(Id);
    handleModalSearchQuery("");
  }, []);

  const handleQuizPopUp = useCallback((Idd) => {
    setIdd(Idd);
    handleModalSearchQuerys("");
  }, []);

  let classNamee = "";
  data?.map((i) => {
    if (i.Id === selectedClassId) {
      classNamee = i.ClassNames;
    }
  });

  const handleUserClassData = () => {
    handleUserPopUp(0);
  };

  const handleQuizData = () => {
    handleQuizPopUp(0);
  };

  useEffect(() => {
    let newTableColumns = columns(navigate, handleUserPopUp);
    setTableColumns(newTableColumns);
  }, [columns, navigate, handleUserPopUp]);

  useEffect(() => {
    let newTableColumnss = modalColumns(navigate, handleQuizPopUp);
    setTableColumnss(newTableColumnss);
  }, [modalColumns, navigate, handleUserPopUp]);

  const onUserGroupSelected = (selected) => {
    setSelectedUserGroup(selected);
  };

  const onClassNameSelected = (selected) => {
    setSelectedClassName(selected);
  };

  const [isClicked, setIsClicked] = useState(false);
  const handleReset = () => {
    setSelectedUser("");
    setSelectedClassName([]);
    setIsClicked(false);
    setSelectedUserGroup([]);
    setSelectedClassId("");
    setSelectedUserId(0);
    setUpdatedUserGroups(userGroup);
    setUpdatedUserClassName(className);
    reset();
  };

  const onFilterSearch = () => {
    setIsClicked(true);
    handleSearchQuery("");
    // console.log(selectedUser, "-------");
  };

  const handleClick = () => {
    dispatch(
      getQuizReportActionHanlder(
        "",
        pageNumber,
        pageSize,
        "",
        "",
        "",
        selectedClassId,
        fromDate,
        toDate,
        selectedUser,
        selectedUserGroupId,
        "Extract",
        setReportActionLoader
      )
    );
  };

  const handleModalClick = () => {
    dispatch(
      getDrillDownQuizReportActionHandler(
        "",
        pageNumber,
        pageSize,
        "",
        "",
        "",
        selectedClassId,
        "Extract",
        setQuestionData,
        setModalDataLoader
      )
    );
  };

  const handleBack = () => {
    setIdd(0);
  };

  const [formData, setFormData] = useState([]);
  useEffect(() => {
    let formArgs = {
      selectedClassName,
      classNameOptions,
      onClassNameSelected,
      selectedUserGroup,
      userGroupOptions,
      selectedUser,
      onUserGroupSelected,
      setSelectedUser,
      userOptions,
    };

    let data = inputField(formArgs);
    setFormData(data);
  }, []);

  //mukesh changes
  //classes
  const [userClassNameList, setUserClassNameList] = useState([]);
  let setUpdatedUserClassName = useCallback(
    (className) => {
      if (className?.length > 0) {
        let updatedUserGroup = className.map((userGroup) => {
          return { ...userGroup, isVisible: true };
        });
        setUserClassNameList(updatedUserGroup);
      }
    },
    [className, userClassNameList]
  );
  useEffect(() => {
    setUpdatedUserClassName(className);
  }, [className]);

  useEffect(() => {
    // cleanup
    return () => {
      dispatch(getClassNameAction([]));
      dispatch(getUserGroupAction([]));
      dispatch(getTenantUsersAction([]));
    };
  }, [dispatch]);

  useEffect(() => {
    if (userClassNameList.length > 0) {
      const filtered = userClassNameList.filter((item) => {
        return item.checked === true;
      });
      if (filtered.length > 0) {
        let updateFilteredResult = filtered.map((item) => {
          return { value: item.TypeId };
        });
        setSelectedClassName(updateFilteredResult);
        // setSelectedClassId(updateFilteredResult);
      } else {
        setSelectedClassName([]);
      }
    }
  }, [userClassNameList, setSelectedClassName]);
  // userGroups
  const [userGroupList, setUserGroupList] = useState([]);
  let setUpdatedUserGroups = useCallback(
    (userGroup) => {
      if (userGroup?.length > 0) {
        let updatedUserGroup = userGroup.map((classes) => {
          return { ...classes, isVisible: true };
        });
        setUserGroupList(updatedUserGroup);
        // setSelectedUserGroup(userGroup);
      }
    },
    [userGroup, userGroupList]
  );
  useEffect(() => {
    setUpdatedUserGroups(userGroup);
  }, [dispatch, userGroup]);

  useEffect(() => {
    if (userGroupList.length > 0) {
      const filtered = userGroupList.filter((item) => {
        return item.checked === true;
      });
      if (filtered.length > 0) {
        setBooleanSelectUser(true);
        let updateFilteredResult = filtered.map((item) => {
          return { label: item.Name, value: item.TypeId };
        });
        setSelectedUserGroup(updateFilteredResult);
        setSelectedUserGroupId(updateFilteredResult[0]?.label);
      } else {
        setBooleanSelectUser(false);
        setSelectedUserGroupId("");
      }
    }
  }, [userGroupList]);
  useEffect(() => {
    if (selectedUserGroup?.length > 0) {
      const groupValue = [];
      selectedUserGroup?.map((e) => groupValue.push(e.Name || e.label));
      setSelectedUserGroupId(groupValue);
    }
  }, [selectedUserGroup, userGroup, setSelectedUserGroupId]);

  // tenantusers
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(quizReportSchema),
  });
  const {
    formState: { errors },
    reset,
    getValues,
    watch,
  } = methods;
  const [accessReportTenantUser, setAccessReportTenantUser] = useState([]);
  useEffect(() => {
    if (tenantUsers?.length > 0) {
      const updatedTrainingTypes = tenantUsers?.map((users) => {
        return {
          ...users,
          isVisible: true,
          fullName: users?.FirstName + " " + users?.LastName,
        };
      });
      setAccessReportTenantUser(updatedTrainingTypes);
    }
  }, [tenantUsers, setAccessReportTenantUser]);
  const handleTenantUsers = (e) => {
    const detailsData = getValues();
    setSelectedUser(detailsData.tenantUserName[0].Id);
    // setSelectedClassName(className);
    // setSelectedUserGroupId(detailsData.tenantUserName[0].Id)
  };
  const watchuserGroup = watch("userGroup");
  const wathclasses = watch("ClassName");
  return (
    <>
      {" "}
      <MainLayout navLinks={navLinks(navigate, tenantName)}>
        <div className={classes.reportFilter_Main}>
          <div className={classes.reportFilter_userCLass}>
            {/* <Dropdown
              isMulti
              // isRequired
              name={"className"}
              label={"Select Shotclasses"}
              isLimit
              defaultValue={selectedClassName}
              placeholder="Select Classes"
              options={classNameOptions}
              onChange={onClassNameSelected}
              maxSelected={10}
              validationLabel=""
              selectedValue={selectedClassName}
            /> */}
            {/* <Dropdown
              isMulti
              // isRequired
              name={"userGroup"}
              label={<FormattedMessage id="Report_UserGroups" />}
              isLimit
              defaultValue={selectedUserGroup}
              placeholder={intl.formatMessage({
                id: `SELECT_USER_GROUP`,
              })}
              options={userGroupOptions}
              onChange={onUserGroupSelected}
              maxSelected={5}
              isDisabled={selectedUser?.length > 0}
              validationLabel="Groups"
              selectedValue={selectedUserGroup}
            />
            <Dropdown
              // isRequired
              name={"user"}
              // isLimit
              // isMulti
              maxSelected={1}
              label={"Select User"}
              defaultValue={selectedUser}
              placeholder={intl.formatMessage({
                id: `Select_Users`,
              })}
              options={userOptions}
              onChange={(e) => setSelectedUser(e.target.value)}
              validationLabel="User"
              isInputDisabled={selectedUserGroup?.length > 0}
              selectedValue={selectedUser}
            /> */}
            <FormProvider {...methods}>
              <InputHookForm
                label={<FormattedMessage id="SELECT_CLASSES" />}
                name="ClassName"
                // labelColor="light"
                type="noSearchTags"
                fieldName={"Name"}
                fieldValue="TypeId"
                placeholder={intl.formatMessage({
                  id: `SELECT_CLASSES`,
                })}
                labelMsg="(Max: 10 Classes)"
                height="3.9"
                width="24.5"
                labelColor={"#404040"}
                searchable={true}
                id={"TypeId"}
                searchTagsList={userClassNameList}
                handleTagList={(tagsList) => {
                  setUserClassNameList(tagsList);
                }}
                error={errors?.ClassName?.message}
              />
              <InputHookForm
                label={<FormattedMessage id="SELECT_USER_GROUP" />}
                name="userGroup"
                // labelColor="light"
                type="noSearchTags"
                fieldName={"Name"}
                fieldValue="TypeId"
                placeholder={intl.formatMessage({
                  id: `SELECT_USER_GROUP`,
                })}
                labelMsg="(Max: 5 Groups)"
                height="3.9"
                width="25"
                labelColor={"#404040"}
                searchable={true}
                id={"TypeId"}
                searchTagsList={userGroupList}
                handleTagList={(tagsList) => {
                  setUserGroupList(tagsList);
                }}
                disabled={selectedUser ? true : false}
                error={errors?.userGroup?.message}
              />
              <InputHookForm
                label={<FormattedMessage id="SELECT_USER" />}
                labelColor="dark"
                name="tenantUserName"
                fieldName={"fullName"}
                fieldValue="Id"
                type="noSearchTags"
                tagType="single"
                buttonLabel={intl.formatMessage({
                  id: `SELECT_USER`,
                })}
                placeholder={intl.formatMessage({
                  id: `Select_Users`,
                })}
                searchTagsList={accessReportTenantUser}
                handleTagList={(tagsList) => {
                  setAccessReportTenantUser(tagsList);
                }}
                id={"Id"}
                height="4"
                searchable={true}
                disabled={booleanSelectUser ? true : false}
                isTagCheckBoxVisible={false}
                addedTagsVisible={false}
                onChange={handleTenantUsers}
                width={"25"}
              />
            </FormProvider>
            <div className={classes.searchResetButton}>
              <span
                style={{
                  textDecoration: "underline",
                  color: "#0051BC",
                  cursor: "pointer",
                  paddingTop: "12px",
                }}
                onClick={handleReset}
              >
                <FormattedMessage id="Report_Reset_btn" />
              </span>
              <Button
                label={<FormattedMessage id="P_Search" />}
                dark
                small
                className={classes.searchButton}
                onClick={onFilterSearch}
                disabled={
                  watchuserGroup?.length > 5 || wathclasses?.length > 10
                    ? true
                    : false
                }
              />
            </div>
          </div>
        </div>
      </MainLayout>
      {isClicked && (
        <div className={classes.tabularDataTable}>
          <DataTable
            columns={tableColumns}
            defaultData={data}
            setDefaultData={setData}
            data={updatedData}
            setData={setUpdatedData}
            totalRows={totalRows}
            uniqueFieldName={"ClassName"}
            onDownload={() => handleClick()}
            downloadable
            downloadText="Download CSV"
            fetchMoreData={handleCurrentPage}
            loading={reportActionloader}
          />
          <Modal
            handleSubmit={handleUserClassData}
            isOpen={Id}
            heading={"Quiz Report"}
            toggle={() => handleUserPopUp()}
            width={"100"}
            height={"59"}
            isScroll
          >
            {Idd ? (
              <div className={classes.questionLevel}>
                <span className={classes.backIcon} onClick={handleBack}>
                  <PreviousIcon fill={colors.theme} />{" "}
                  <FormattedMessage id="BACK" />
                </span>
                {/* <Button
                  label="Back"
                  dark
                  small
                  className={classes.searchButton}
                  onClick={handleBack}
                /> */}
                <div>
                  {/* {modalsData?.SelectedQuestion?.map((e) => { */}
                  {/* return ( */}
                  {/* <> */}
                  <div className={classes.classNameHeading}>
                    <h4>% of correct response:</h4>
                    <p className={classes.userName}>
                      {modalsData?.SelectedQuestion?.PercentCorrectResponse}
                    </p>
                  </div>
                  <div className={classes.mainHeadingModal}>
                    <p className={classes.fieldName}>Q1.</p>
                    {modalsData?.SelectedQuestion?.QuestionText}
                  </div>

                  <div className={classes.choiceTextListMain}>
                    {modalsData?.SelectedQuestion?.QuestionMediaUri && (
                      <img
                        src={modalsData?.SelectedQuestion?.QuestionMediaUri}
                        alt="ques_image"
                        className={classes.quesImage}
                      />
                    )}
                    <div
                      className={
                        modalsData?.SelectedQuestion?.ChoiceList[0]
                          .ChoiceMediaUri
                          ? classes.choiceImageList
                          : classes.choiceTextList
                      }
                    >
                      {modalsData?.SelectedQuestion?.ChoiceList?.map(
                        (e, index) => {
                          if (
                            modalsData?.SelectedQuestion?.ChoiceList[0]
                              .ChoiceMediaUri
                          ) {
                            return (
                              <div
                                key={e?.ChoiceId}
                                className={classes.choiceImageListItem}
                              >
                                <img
                                  src={e?.ChoiceMediaUri}
                                  alt="choice_image"
                                  className={classes.choiceImage}
                                />
                                <div className={classes.ques}>
                                  <b>{index + 1}.</b> {e?.ChoiceText}
                                </div>
                              </div>
                            );
                          } else {
                            return (
                              <div
                                className={classes.choiceTextListItem}
                                key={e?.ChoiceId}
                              >
                                {e.IsAnswer ? (
                                  <div className={classes.answerItem}>
                                    <TickIcon fill="#43E57A" />
                                    <p className={classes.choiceText}>
                                      {index + 1}.&nbsp;{e.ChoiceText}
                                    </p>
                                  </div>
                                ) : (
                                  <div className={classes.listItem}>
                                    <p className={classes.choiceText}>
                                      {index + 1}.&nbsp;{e.ChoiceText}
                                    </p>
                                  </div>
                                )}
                              </div>
                            );
                          }
                        }
                      )}
                    </div>
                  </div>
                  <div>
                    <DataTable
                      columns={modalColumnss(navigate)}
                      // defaultData={data}
                      // setDefaultData={setData}
                      data={modalsData?.UserResponse}
                      // setData={setUpdatedData}
                      // searchable
                      totalRows={modalsData?.ToralRows}
                      uniqueFieldName={"ClassName"}
                      onDownload={handleModalClick}
                      fetchMoreData={handlerModalCurrentPage}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div>
                  {questionData?.map((e) => {
                    return (
                      <>
                        <div className={classes.classNameHeading}>
                          <h4>Class Name:</h4>
                          <p className={classes.userName}>{e.ClassNames}</p>
                        </div>
                        <div className={classes.mainHeadingModal}>
                          <p className={classes.fieldName}>
                            Total User Completed
                          </p>
                          {e.CompletedUsersCount}
                          <p className={classes.fieldName}>
                            Total Quiz Questions
                          </p>
                          {e.QuizQuestionsCount}
                          <p className={classes.fieldName}>Pass Mark </p>
                          {e.PassMarks}
                          <p className={classes.fieldName}>
                            {" "}
                            Average Quiz Score{" "}
                          </p>
                          {e.AverageQuizScore}
                        </div>
                      </>
                    );
                  })}
                </div>
                <div>
                  <DataTable
                    columns={tableColumnss}
                    // defaultData={data}
                    // setDefaultData={setData}
                    data={modalData}
                    // setData={setUpdatedData}
                    totalRows={setModalTotalRows}
                    uniqueFieldName={"ClassName"}
                    onDownload={handleModalClick}
                    fetchMoreData={handlerModalCurrentPage}
                    downloadable
                    loading={modalDataLoader}
                  />
                </div>
              </>
            )}
          </Modal>
        </div>
      )}
    </>
  );
};

export default injectIntl(QuizReportPage);
